import { render } from "./UserPanel.vue?vue&type=template&id=7c207c0e&scoped=true"
import script from "./UserPanel.vue?vue&type=script&lang=js"
export * from "./UserPanel.vue?vue&type=script&lang=js"

import "./UserPanel.vue?vue&type=style&index=0&id=7c207c0e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7c207c0e"

export default script